import { TAiMessage } from 'types/ai';

export enum ERegisterType {
    KIWI_PORTAL = 'KIWI_PORTAL',
    KLARITY_PORTAL = 'KLARITY_PORTAL',
}

const PREFIX = 'box_practice';

export enum EKey {
    SKIP_CHANNEL_CARE = 'skip_channel_care',
    RESET_FAIL_EMAIL = 'reset_fail_email',
    AI_SEARCH_NAME = 'ai_search_name',
    AI_SEARCH_ID = 'ai_search_id',
    SHOW_KIWI_PLAN_ADVERTISE = 'show_kiwi_plan_advertise',
    CLICK_SKIP_WEBINAR = 'click_skip_webinar',
    CONFIG_PROGRAM_FROM_TABLE = 'config_program_from_table',
    CONFIGING_PROGRAM_ID = 'configing_program_id',
    SHOW_WEBINAR_POP_IN_CURRENT_SESSION = 'show_webinar_pop_in_current_session',
    HELP_CENTER_ACTIVE_KEY = 'help_center_active_key',
    HAS_CHANGE_DATE_FROM_URL = 'has_change_date_from_url',
    LATEST_ACTIVE_TIME = 'latest_active_time',
    AI_CHAT_HISTORY_MESSAGE = 'ai_chat_history_message',
    CURRENT_PLATFORM_TYPE = 'current_platform_type',
    MEETING_UUID = 'meeting_uuid',
    PREVIEW_SCHEDULE_TOKEN = 'preview_schedule_token',
    PREVIEW_ADMIM_TOKEN = 'preview_admin_token',
    PREVIEW_PROVIDER_ID = 'preview_provider_id',
    VIEW_MODE = 'view_mode',
}

const getKey = (key: EKey): string => {
    return `${PREFIX}_${key}`;
};

const setSkipChannelCare = (data: boolean) => {
    const key = getKey(EKey.SKIP_CHANNEL_CARE);
    if (!data) {
        sessionStorage.removeItem(key);
    }
    sessionStorage.setItem(key, JSON.stringify(data));
};

const getSkipChannelCare = (): boolean => {
    const key = getKey(EKey.SKIP_CHANNEL_CARE);
    const str = sessionStorage.getItem(key);
    if (!str) {
        return false;
    }
    return true;
};

const setResetFailEmail = (email?: string) => {
    const key = getKey(EKey.RESET_FAIL_EMAIL);
    if (!email) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, email);
};

const getResetFailEmail = (): string | undefined => {
    const key = getKey(EKey.RESET_FAIL_EMAIL);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setAiSearchName = (name: string) => {
    const key = getKey(EKey.AI_SEARCH_NAME);
    if (!name) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, name);
};

const getAiSearchName = (): string | undefined => {
    const key = getKey(EKey.AI_SEARCH_NAME);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setAiSearchId = (id: string) => {
    const key = getKey(EKey.AI_SEARCH_ID);
    if (!id) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, id);
};

const getAiSearchId = (): string | undefined => {
    const key = getKey(EKey.AI_SEARCH_ID);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setShowKiwiPlanAdvertise = (val: boolean | undefined) => {
    const key = getKey(EKey.SHOW_KIWI_PLAN_ADVERTISE);
    if (!val) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, `${val}`);
};

const getShowKiwiPlanAdvertise = (): boolean | 'idel' => {
    const key = getKey(EKey.SHOW_KIWI_PLAN_ADVERTISE);
    const str = sessionStorage.getItem(key);
    if (!str) {
        return 'idel';
    }
    return str === 'true';
};

const getClickSkipWebinar = (): boolean => {
    const key = getKey(EKey.CLICK_SKIP_WEBINAR);
    const str = sessionStorage.getItem(key);
    return !!str;
};

const setClickSkipWebinar = (val: boolean | undefined) => {
    const key = getKey(EKey.CLICK_SKIP_WEBINAR);
    if (!val) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, `${val}`);
};

const setConfigProgramFromTable = (val: boolean | undefined) => {
    const key = getKey(EKey.CONFIG_PROGRAM_FROM_TABLE);
    if (!val) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, `${val}`);
};

const getConfigProgramFromTable = (): boolean => {
    const key = getKey(EKey.CONFIG_PROGRAM_FROM_TABLE);
    const str = sessionStorage.getItem(key);
    return !!str;
};

const setConfigingProgramId = (id?: string) => {
    const key = getKey(EKey.CONFIGING_PROGRAM_ID);
    if (!id) {
        sessionStorage.removeItem(key);
        return;
    }
    sessionStorage.setItem(key, id);
};

const getConfigingProgramId = (): string | undefined => {
    const key = getKey(EKey.CONFIGING_PROGRAM_ID);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setHasShowWebinarPopInCurrentSession = (data: boolean) => {
    const key = getKey(EKey.SHOW_WEBINAR_POP_IN_CURRENT_SESSION);
    if (!data) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, 'true');
    }
};

const getHasShowWebinarPopInCurrentSession = (): boolean => {
    const key = getKey(EKey.SHOW_WEBINAR_POP_IN_CURRENT_SESSION);
    const str = sessionStorage.getItem(key);
    if (!str) {
        return false;
    }
    return true;
};

const setHelpCenterActiveKey = (key?: string) => {
    const k = getKey(EKey.HELP_CENTER_ACTIVE_KEY);
    if (!key) {
        sessionStorage.removeItem(k);
        return;
    }
    sessionStorage.setItem(k, key);
};

const getHelpCenterActiveKey = (): string | undefined => {
    const k = getKey(EKey.HELP_CENTER_ACTIVE_KEY);
    const str = sessionStorage.getItem(k);
    return str || undefined;
};

const setHasChangeDateFromUrl = (data: boolean) => {
    const key = getKey(EKey.HAS_CHANGE_DATE_FROM_URL);
    if (!data) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, 'true');
    }
};

const getHasChangeDateFromUrl = (): boolean => {
    const key = getKey(EKey.HAS_CHANGE_DATE_FROM_URL);
    const str = sessionStorage.getItem(key);
    if (!str) {
        return false;
    }
    return true;
};

const setLatestActiveTime = (time: number) => {
    const key = getKey(EKey.LATEST_ACTIVE_TIME);
    if (!time) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, `${time}`);
    }
};

const getLatestActiveTime = (): number => {
    const key = getKey(EKey.LATEST_ACTIVE_TIME);
    const str = sessionStorage.getItem(key);
    if (str) {
        try {
            return parseInt(str, 10);
        } catch (e) {
            return 0;
        }
    }
    return 0;
};

const setAiChatHistoryMessage = (message: TAiMessage[]) => {
    const key = getKey(EKey.AI_CHAT_HISTORY_MESSAGE);
    sessionStorage.setItem(key, JSON.stringify(message));
};

const getAiChatHistoryMessage = (): TAiMessage[] => {
    const key = getKey(EKey.AI_CHAT_HISTORY_MESSAGE);
    const str = sessionStorage.getItem(key);
    if (!str) {
        return [];
    }
    try {
        return JSON.parse(str);
    } catch (e) {
        return [];
    }
};

const getCurrentPlatformType = (): ERegisterType | undefined => {
    const key = getKey(EKey.CURRENT_PLATFORM_TYPE);
    const str = sessionStorage.getItem(key) as ERegisterType;
    return str || undefined;
};

const setCurrentPlatformType = (type: ERegisterType) => {
    const key = getKey(EKey.CURRENT_PLATFORM_TYPE);
    sessionStorage.setItem(key, type);
};

const setMeetingUuid = (data?: string) => {
    try {
        const key = getKey(EKey.MEETING_UUID);
        if (!data) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, data);
        }
    } catch (e) {
        console.error(e);
    }
};

const getMeetingUuid = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    const key = getKey(EKey.MEETING_UUID);
    const str = sessionStorage.getItem(key);
    if (str) {
        return str;
    }
    return undefined;
};

const setPreviewScheduleToken = (token?: string) => {
    const key = getKey(EKey.PREVIEW_SCHEDULE_TOKEN);
    if (!token) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, token);
    }
};

const getPreviewScheduleToken = (): string | undefined => {
    const key = getKey(EKey.PREVIEW_SCHEDULE_TOKEN);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setPreviewAdminToken = (token?: string) => {
    const key = getKey(EKey.PREVIEW_ADMIM_TOKEN);
    if (!token) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, token);
    }
};

const getPreviewAdminToken = (): string | undefined => {
    const key = getKey(EKey.PREVIEW_ADMIM_TOKEN);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setViewMode = (mode?: string) => {
    const key = getKey(EKey.VIEW_MODE);
    if (!mode) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, mode);
    }
};

const getViewMode = (): string | undefined => {
    const key = getKey(EKey.VIEW_MODE);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

const setPreviewProviderId = (id?: string) => {
    const key = getKey(EKey.PREVIEW_PROVIDER_ID);
    if (!id) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, id);
    }
};

const getPreviewProviderId = (): string | undefined => {
    const key = getKey(EKey.PREVIEW_PROVIDER_ID);
    const str = sessionStorage.getItem(key);
    return str || undefined;
};

export {
    setPreviewProviderId,
    getPreviewProviderId,
    setViewMode,
    getViewMode,
    setPreviewScheduleToken,
    getPreviewScheduleToken,
    setPreviewAdminToken,
    getPreviewAdminToken,
    setSkipChannelCare,
    getSkipChannelCare,
    setResetFailEmail,
    getResetFailEmail,
    setAiSearchName,
    getAiSearchName,
    setAiSearchId,
    getAiSearchId,
    setShowKiwiPlanAdvertise,
    getShowKiwiPlanAdvertise,
    getClickSkipWebinar,
    setClickSkipWebinar,
    setConfigProgramFromTable,
    getConfigProgramFromTable,
    setConfigingProgramId,
    getConfigingProgramId,
    setHasShowWebinarPopInCurrentSession,
    getHasShowWebinarPopInCurrentSession,
    setHelpCenterActiveKey,
    getHelpCenterActiveKey,
    getHasChangeDateFromUrl,
    setHasChangeDateFromUrl,
    setLatestActiveTime,
    getLatestActiveTime,
    setAiChatHistoryMessage,
    getAiChatHistoryMessage,
    getCurrentPlatformType,
    setCurrentPlatformType,
    getMeetingUuid,
    setMeetingUuid,
};
